import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AgendaView.html?raw';
import on from 'dojo/on';
import dojoDate from 'dojo/date';
import DatePicker from '../DatePicker/DatePicker';
import "../DatePicker/DatePicker";
import StaticTable from '../StaticTable/StaticTable';
import "../StaticTable/StaticTable";
import "../SelectBox/SelectBox";
import { ColorHelpers, DateHelpers, HtmlHelpers } from "../../../more/Helpers";
import GenericEntityView from '../EntityBased/EntityView/GenericEntityView';
import FloatingContainer from '../Floating/FloatingContainer';
import { AgendaViewTypes } from "../../../WidgetCollection/AgendaViewBase/AgendaViewBaseTypes";
import { FinderTypes } from "../../../WidgetCollection/FinderBase/FinderBaseTypes";


interface AgendaViewSettings {
    internalName: string,
    userId: string,
    lastSetLayoutname: string
}
interface AgendaViewConfig<T> {
    navigationDate?: Date,
    selectedDate?: Date,
    initialGotoDate?: Date,
    earliestDate?: Date,
    latestDate?: Date,
    showAppointmentLabels?: boolean,
    layouts?: StaticTable.Layout[],
    tablerowExpanderConfig?: FinderTypes.TableRowExpanderConfig<T>
}
class AgendaView<T> extends compose(_WidgetBaseSP) {
    templateString: any = template;
    datePicker: MdsLax<InstanceType<typeof DatePicker>>;
    private datepickerContainer: HTMLElement;
    private filterPanelContainer: HTMLElement;
    resultTable: MdsLax<InstanceType<typeof StaticTable<T>>>;
    internalName: string;
    private _layouts: Array<StaticTable.Layout>;

    private listContainer: HTMLDivElement;
    private layoutSelectContainer: HTMLDivElement;
    private listData: Array<any>;

    _currentMonthDate: Date;
    private _currentVisibleStart: Date;
    private _currentVisibleEnd: Date;
    private _dateSelectCallback: (entries: Array<any>, dates: Array<Date>) => any = null;

    private earliestDate: Date = null;
    private latestDate: Date = null;


    rowClickFunction: StaticTable.rowclickCallback = function openDetails(row: StaticTable.StaticTableRow<more.EntityAPIResultExtended>, group: StaticTable.StaticTableRowGroup<more.EntityAPIResultExtended>) {
        let view = new GenericEntityView();
        try {
            view.setup(group.entity.ID, group.entity.Classname, group.entity.$Displayname, "dlg");
        } catch (ex) {

        }
        
    };

    setDateLimits(earliestDate?: Date, latestDate?: Date) {
        if (earliestDate) {
            this.earliestDate = earliestDate;
            if (this.datePicker) this.datePicker.earliestDate = this.earliestDate;
        }
        if (latestDate) {
            this.latestDate = latestDate;
            if (this.datePicker) this.datePicker.latestDate = this.latestDate;
        }

    }

    setDate(date: Date) {
        this.datePicker.setValue(date);
    }

    /**
     * Gibt das gewählte Datum der Agendaview zurück.
     * @returns
     */
    getSelectedDate(): Date {
        if (this._selectedDates?.length) {
            return this._selectedDates[0];
        }

        return null;
    }

    private _selectedDates: Array<Date>;
    private _onChange_DatepickerDate(dates: Array<Date>) {
        //console.log("_onChange_DatepickerDate", dates);
        this.emit("dateChanged", dates);
        let list = [];
        let shortDates = [];
        this._selectedDates = [];
        
        if (dates && dates.length) {
            for (let date of dates) {
                shortDates.push(this.datePicker.getShortDate(date));
            }

            if (this.listData && this.listData.length) {
                for (let listEntry of this.listData) {
                    if (shortDates.indexOf(listEntry["_agendaViewShortDate"], 0) != -1) {
                        list.push(listEntry);
                    }
                }
            }
        } else {
            list = this.listData;
        }

        if( dates?.length) this._selectedDates = lang.clone(dates);

        if (this._dateSelectCallback) {
            this._dateSelectCallback(list, dates);
        }

        if (this._layouts && this._layouts.length) {
            this._redrawTable(list);
        }
        
    }

    private _onChange_DatepickerPage(date: Date) {

        if (!date) date = this._currentMonthDate;

        //console.log("_onChange_DatepickerPage", date);
        this.disableNode(this.listContainer);
        this.datePicker.setValue(null);
        this._currentMonthDate = date;
        this._currentVisibleStart = this.datePicker.getFirstVisibleDate();
        this._currentVisibleEnd = this.datePicker.getLastVisibleDate();
        this.emit("monthChanged", date);
    }

    getExtendedStartDate(): Date {
        return this._currentVisibleStart;
    }
    getExtendedEndDate(): Date {
        return this._currentVisibleEnd;
    }
    //_changeDate() {
    //    this._modifyCalendarTable();

    //    this.emit("dateChanged", this.datePicker.getValue());
    //}

    private _loadLocaleSettings(): Array<AgendaViewSettings> {
        let result = [];
        let userId = this.getCurrentUserId();
        if (!this.hasFeature("System/SaveLocalLayoutSettings")) return result;
        if (!userId) return result;


        try {
            let str = localStorage.getItem("ego_AgendaViewSettings");

            if (str) {
                let storedSettings: Array<AgendaViewSettings> = JSON.parse(str);

                return storedSettings;
            }

        } catch (ex) {
            return [];
        }

        return result;
    }

    private _getLocalTableSetting(): AgendaViewSettings {
        let targetName = this.internalName;
        if (!targetName) return null;

        let localSettings = this._loadLocaleSettings();
        let userId = this.getCurrentUserId();

        for (let setting of localSettings) {
            if (setting.internalName == targetName && setting.userId == userId) {
                return setting;
            }
        }

        return null;
    }

    private _saveLocalTableSetting(data: AgendaViewSettings) {
        if (!this.hasFeature("System/SaveLocalLayoutSettings")) return;
        if (!data) return;

        let localSettings = this._loadLocaleSettings();

        for (let i = 0; i < localSettings.length; i++) {
            let setting = localSettings[i];
            if (setting.internalName == data.internalName && setting.userId == data.userId) {
                localSettings.splice(i, 1);
            }
        }

        localSettings.push(data);

        localStorage.setItem("ego_AgendaViewSettings", JSON.stringify(localSettings));
    }

    private _onTableLayoutChanged(newLayout: StaticTable.Layout) {
        if (newLayout) {
            this._saveLocalTableSetting({
                internalName: this.internalName,
                lastSetLayoutname: newLayout.name,
                userId: this.getCurrentUserId()
            });
        }
    }

    setLayouts(layouts: Array<StaticTable.Layout>, expanderConfig?: StaticTable.ExpanderConfig<T>) {

        if (layouts) {
            //set data for StateSelectbox
            this._layouts = layouts;
        }

        if (!this._layouts?.length) console.error(this.id + ": no tablelayouts!");

        if (this.resultTable) {
            for (let layout of layouts) {
                this.resultTable.addLayout(layout);
            }
        }

        if (this.internalName) {
            let setting = this._getLocalTableSetting();
            if (setting) this.resultTable.setLayoutByName(setting.lastSetLayoutname);

            if (expanderConfig) {
                this.resultTable.setupExpandableRows(expanderConfig);
            }
        }
    }

    private onViewChange(layoutName: string) {
        
        this._redrawTable()
    }

    protected _getLayoutByName(name: string): StaticTable.Layout {
        //console.log("this._layouts: ", this._layouts);
        
        if (this._layouts) {

            if (Array.isArray(this._layouts)) { // das wird bei der BST der Fall sein
                for (var layout of this._layouts) {
                    if (layout.name == name) {
                        return layout;
                    }
                }
            } else {
                console.log("this._layouts is NOT an array, most likely you are using the wrong Layouts Configuration Structure for BST.");
            }
        }

        return null;
    }
    private _holidays: Record<string, (AgendaViewTypes.HolidayDescriptor & { tooltipNode: HTMLElement })[]>;
    setEntries(data: Array<AgendaViewTypes.AgendaViewEntry<any>>, holidays?: Array<AgendaViewTypes.HolidayDescriptor>, gotoDate?: Date) {

        this.listData = [];
        this._holidays = {};

        this.datePicker.emptyAppointments();

        // Achtung: Icons kommen (ggf.) auch für die "Extratage" am vorderen und hinteren Monat
        // vom Datepicker erhalten wir aber den selektierten Monat und können uns hier mal die Datumsgrenzen errechnen, ohne die Extratage:
        let selectedMonthDateStart = this._currentMonthDate;
        let selectedMonthDateEnd = new Date(selectedMonthDateStart.getFullYear(), selectedMonthDateStart.getMonth() + 1, 1, 0, 0, 0);//.toISOString();//.substring(0, 10);
        selectedMonthDateEnd.setSeconds(selectedMonthDateEnd.getSeconds() - 1);

        let keyDate: Date = null;

        for (let entry of data) {
            if (typeof (entry.date) == "string") {
                keyDate = new Date(<any>entry.date);
            } else {
                keyDate = entry.date;
            }

            let dayTxt = new Date(keyDate.getFullYear(), keyDate.getMonth(), keyDate.getDate(), 0, 0, 0, 0).toString();
            let groupValue = dayTxt + "-" + entry.iconClass + entry.iconColoration;
            this.datePicker.addAppointmentIcon(keyDate, entry.iconClass, groupValue, entry.tooltip,    null, entry.iconColoration);

            // in der Tabelle nur anzeigen, was wirklich als Monat ausgewählt wurde
            if (keyDate.valueOf() <= selectedMonthDateEnd.valueOf() &&
                keyDate.valueOf() >= selectedMonthDateStart.valueOf() )
            if (entry.entityData) {

                entry.entityData["_agendaViewShortDate"] = this.datePicker.getShortDate(keyDate); // weil die Agendaview der STatictable eine Gruppierung nach date einfügt...
                entry.entityData["_agendaViewDateLabel"] = DateHelpers.dateToString(keyDate, "EEEE dd.MM.yyyy"); // weil die Agendaview der STatictable eine Gruppierung nach date einfügt...
                //entry.entityData["date"] = DateHelpers.dateToString(keyDate, "EEEE dd.MM.yyyy") // weil die Agendaview der STatictable eine Gruppierung nach date einfügt...
                // und wir wissen, dass ein Agendaview-Entry immer ein date hat, aber wir nicht wissen, ob entityData auch ein date hat

                this.listData.push(entry.entityData);
            }
        }

        if (holidays?.length) {
            for (let holiday of holidays) {
                let holidate: Date = holiday.date as Date;
                if (typeof (holiday.date) == "string") {
                    holidate = new Date(holiday.date);
                }

                let tooltipContentNode = this.UiModder.domConstruct.create("div", {
                    className: "tooltipContent"
                });

                let startDate: Date = holiday.start as Date;
                if (typeof(holiday.start) == "string") {
                    startDate = new Date(holiday.start);
                }

                let endDate: Date = holiday.end as Date;

                if (typeof (holiday.end) == "string") {
                    endDate = new Date(holiday.end);
                }

                if (!holiday.end) endDate = startDate;

                let startStr = DateHelpers.dateToString(startDate);
                let endStr = DateHelpers.dateToString(endDate);

                let dateInfo = this.UiModder.domConstruct.create("div", {
                    className: "dateRange",
                    innerHTML: startStr
                }, tooltipContentNode);

                if (startStr != endStr) {
                    dateInfo.innerHTML = startStr + " - " + endStr;
                }

                if (holiday.tooltipContent) {
                    let node = this.UiModder.domConstruct.create("div", {
                        className: "",
                        innerHTML: holiday.tooltipContent
                    }, tooltipContentNode);

                    if (node.hasChildNodes()) {
                        this.UiModder.domClass.add(node, "htmlContent");
                    }
                }

                this.datePicker.addHoliday(holidate,
                    holiday.iconClass,
                    holiday.title,
                    holiday.hexColorBG,
                    holiday.hexColorTXT,
                    tooltipContentNode);

                let key = this.datePicker.getShortDate(holidate);
                let array = this._holidays[key];
                if (!array) {
                    array = [];
                    this._holidays[key] = array;
                }
                array.push({
                    ...holiday,
                    tooltipNode: tooltipContentNode
                });
            }

           
        }

        this._redrawTable();

    }

    addFilterpanelToTemplate(widget: any) {
        if (widget && widget.placeAt) {
            widget.placeAt(this.filterPanelContainer, "only");
            this.hideNode(this.filterPanelContainer, false);
        } else {
            this.UiModder.domConstruct.empty(this.filterPanelContainer);
            this.hideNode(this.filterPanelContainer);
        }
    }
    redrawTable() {
        this._redrawTable();
    }
    private _initialGotoDateValue: number;
    private _redrawTable(list?: Array<any>) {

        if (!list) list = this.listData;

        this.resultTable.setData(list);
        this.disableNode(this.listContainer, false);
        this.hideNode(this.listContainer, false);
        
        if (this._holidays) {
            let groups = this.resultTable.getGroupingNodes();

            for (let groupvalue in groups) {
                let group = groups[groupvalue];

                let date = new Date(groupvalue);
                let dateStr = this.datePicker.getShortDate(date);

                let holidaysOfDate = this._holidays[dateStr];
                if (holidaysOfDate?.length) {
                    let holidaysContainer = this.UiModder.domConstruct.create("div", {
                        className: "holidaysContainer",

                    }, group.cell);

                    for (let holiday of holidaysOfDate) {
                        let holidayMain = this.UiModder.domConstruct.create("span", {
                            //className: "holiday hoverDark",
                            className: "holiday",
                            innerHTML: holiday.title
                        }, holidaysContainer);

                        //on(holidayMain, "click", lang.hitch(this, this._onClick_Holiday, holiday));

                        let hexColorBG = holiday.hexColorBG;
                        let hexColorTXT = holiday.hexColorTXT;

                        if (hexColorBG) holidayMain.style.setProperty("--holidayBG", hexColorBG);

                        if (!hexColorTXT && hexColorBG) {
                            let isDark = ColorHelpers.isDarkColor(hexColorBG);
                            if (isDark) {
                                this.UiModder.domClass.add(holidayMain, "darkBG");
                            }
                        } else if (hexColorTXT) {
                            holidayMain.style.setProperty("--holidayTXT", hexColorTXT);
                        }
                    }
                }

            }
        }

        if (this._initialGotoDateValue) {
            let targetDate = new Date(this._initialGotoDateValue);
            let targetStr = this.datePicker.getShortDate(targetDate);
            let groups = this.resultTable.getGroupingNodes(targetStr);
            if (groups?.length) groups[0].row.scrollIntoView({ behavior: "smooth", block: "center" });

            this._initialGotoDateValue = null;
        }
    };

    private _onClick_Holiday(holiday: AgendaViewTypes.HolidayDescriptor, evt: MouseEvent) {
        let float = new FloatingContainer();

        evt.stopPropagation();

        let content = this.UiModder.domConstruct.create("div", {
            className: "holidayTooltip",
        });
        let container = this.UiModder.domConstruct.create("div", {
            className: "holidayEntry",
        }, content);

       
        let label = this.UiModder.domConstruct.create("p", {
            className: "holidayLabel",
            innerHTML: holiday.title
        }, container);

        if (holiday.iconClass) {
            HtmlHelpers.createFontawesomeIcon(holiday.iconClass, "right", label);
        }

        if (holiday.tooltipContent) {

            let anyContent = this.UiModder.domConstruct.create("div", {
                className: "",
                innerHTML: holiday.tooltipContent
            }, container);

            if (anyContent.childNodes.length) {
                this.UiModder.domClass.add(anyContent, "htmlContent");
            }

        }
    }

    private _config: AgendaViewConfig<T>;

    setConfig(config: AgendaViewConfig<T>)
    setConfig(navigationDate: Date | null, selectedDate?: Date, earliestDate?: Date, latestDate?: Date)
    setConfig(navigationDateOrConfig: Date | AgendaViewConfig<T>, unknown2?: Date, unknown3?: Date, unknown4?: Date) {

        let config: AgendaViewConfig<T> = null;

        if (typeof (navigationDateOrConfig) == "object" && !!navigationDateOrConfig) {
            // falls es im Legacymode daherkommt, also jeder Parameter einzeln, dann daraus config erstellen und nochmal selber aufrufen.
            if (navigationDateOrConfig["valueOf"] && navigationDateOrConfig["getFullYear"]) {
                this.setConfig({
                    navigationDate: navigationDateOrConfig as Date,
                    selectedDate: unknown2,
                    earliestDate: unknown3,
                    latestDate: unknown4                    
                });

                return;
            } else {
                config = navigationDateOrConfig as any;
            }
        }
        
        if (!config) return;

        this._config = config;
        if (config.initialGotoDate) this._initialGotoDateValue = config.initialGotoDate.valueOf();

        if (!config.navigationDate && !!config.selectedDate) {
            config.selectedDate = config.navigationDate;
        }


        //this.emit("dateChanged", newDate);
        //this.datePicker.setValue(newDate);

        this.setDateLimits(config.earliestDate, config.latestDate);
        this.setLayouts(config.layouts);        

        this.datePicker.emptyAppointments();
        this.datePicker.setup(config.navigationDate, config.selectedDate, this.earliestDate, this.latestDate, config.showAppointmentLabels == true ? "agendaWithLabels" : "agendaNavigation");


        this.datePicker.setupStyles("1rem", "1em", "0.95em", 40 + "px", 1.2, 1.8);

//        this.autoAdjustDatePickerWidth(40);

        this._onChange_DatepickerPage(this.datePicker.getDisplayedMonth());

        this.emit("configSet");

    }

    autoAdjustDatePickerWidth(maxBaseWidth: number = 40) {
        if (!this.datePicker?.domNode?.scrollWidth) return;

        this.datePicker.setupStyles("1rem", "1em", "0.95em", maxBaseWidth + "px", 1.2, 1.8);

        let datePickerWidth = this.datePicker.domNode.clientWidth;// parseFloat(window.getComputedStyle(this.datePicker.domNode).width);


        // ist der Datepicker breiter als EINE seiner Parentnodes?

        let compareNode: HTMLElement = this.datePicker.domNode;
        let isSmallerParent: boolean = false;
        // falls das Ding größer als das Fenster ist, brauchen wir die Parents gar nicht erst prüfen (Performance)
        while (compareNode && !(datePickerWidth > window.innerWidth)) {
            try {
                let width = parseFloat(window.getComputedStyle(compareNode).width);
                if (width < datePickerWidth) {
                    isSmallerParent = true;
                    break;
                }
                compareNode = compareNode.parentElement;
            } catch (ex) {
                break;
            }
        }

        if (maxBaseWidth < 25) return;
        if (datePickerWidth > window.innerWidth || isSmallerParent) {
            maxBaseWidth--;

            setTimeout(lang.hitch(this, this.autoAdjustDatePickerWidth, maxBaseWidth), 160);
        }
    }

    setFormatter(formatter, headingFormatter?: StaticTable.headingFormatterCallback) {
        if (formatter) {
            this.resultTable.setFormatter(formatter);
        }

        if (headingFormatter) {
            this.resultTable.setHeadingLabelFormatter(headingFormatter);
        }

        this._redrawTable();
    }

    getCurrentDisplayedMonth(): Date {
        return  this.datePicker.getDisplayedMonth();
    }

    /**
     * Funktion, die beim Wählen eines neuen Datums aufgerufen wird.
     * Empfängt eine Liste der Events und eine Liste von Dates.
     */
    setDateSelectCallback(callback: (entries: Array<any>, dates: Array<Date>) => any) {
        this._dateSelectCallback = callback;
    }

    setRowClick(rowClickFunction: StaticTable.rowclickCallback) {
        if (rowClickFunction) {
            this.rowClickFunction = rowClickFunction;
        }

        this.resultTable.setRowClick(lang.hitch(this, this.rowClickFunction))
    }



    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        let now = new Date();
        let early = dojoDate.add(now, "year", -2);
        let late = dojoDate.add(now, "year", 2);

        this.earliestDate = early;
        this.latestDate = late;

        this.UiModder.domConstruct.empty(this.datepickerContainer);
        this.datePicker = new DatePicker();

        on(this.datePicker, "change", lang.hitch(this, this._onChange_DatepickerDate));
        on(this.datePicker, "pageChange", lang.hitch(this, this._onChange_DatepickerPage));
        this.datePicker.placeAt(this.datepickerContainer);
        this.hideNode(this.datepickerContainer, false);

        this.UiModder.domConstruct.empty(this.listContainer);
        this.resultTable = new StaticTable();
        this.resultTable.placeAt(this.listContainer);
        this.resultTable.groupingEnabled = true;
        this.resultTable.groupingProperty = "_agendaViewShortDate";
        this.resultTable.groupingLabelProperty = "_agendaViewDateLabel";
        this.resultTable.sortDirection = "ASC";

        this.resultTable.on("layoutChange", lang.hitch(this, this._onTableLayoutChanged));

        this.setRowClick(this.rowClickFunction);

        //// observer damit wir Änderungen am datepicker mitbekommen:
        //let observer = new MutationObserver(lang.hitch(this, this._onDomMutation_DatepickerContainer));
        //observer.observe(this.datepickerContainer, { childList: true });

    }

    //private _onDomMutation_DatepickerContainer(mutationList, observer) {
    //    console.debug("_onDomMutation", mutationList, observer);

    //    this.hideNode(this.datepickerContainer, this.datepickerContainer.childElementCount <= 0);
    //}


    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AgendaView);
